var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.186 32.7295L107.881 54.8692L43.6777 118.488H145.316L196.186 32.7295Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8926 137.542L107.893 200.672L196.445 222.812L145.55 137.542H43.8926Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M213.039 42.4639L162.334 128.007L213.039 213.296L237.553 128.007L213.039 42.4639Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M109.494 57.7407L189.57 37.6582L143.507 115.315H51.3926L109.494 57.7407Z",
    stroke: "black",
    strokeWidth: 1.04167,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M109.494 57.7407L189.57 37.6582L143.507 115.315H51.3926L109.494 57.7407Z",
    stroke: "#1D1D1B",
    strokeWidth: 2.08333
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M109.494 57.7407L189.57 37.6582L143.507 115.315H51.3926L109.494 57.7407Z",
    stroke: "black",
    strokeWidth: 1.04167
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M212.011 205.366L166.023 128.008L212.011 50.4141L234.246 128.008L212.011 205.366Z",
    stroke: "black",
    strokeWidth: 1.04167,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M109.498 197.803L51.6309 140.717H143.745L189.809 217.879L109.498 197.803Z",
    stroke: "black",
    strokeWidth: 1.04167,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M212.011 205.366L166.023 128.008L212.011 50.4141L234.246 128.008L212.011 205.366Z",
    stroke: "#1D1D1B",
    strokeWidth: 2.08333
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M212.011 205.366L166.023 128.008L212.011 50.4141L234.246 128.008L212.011 205.366Z",
    stroke: "black",
    strokeWidth: 1.04167
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M109.498 197.803L51.6309 140.717H143.745L189.809 217.879L109.498 197.803Z",
    stroke: "#1D1D1B",
    strokeWidth: 2.08333
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M109.498 197.803L51.6309 140.717H143.745L189.809 217.879L109.498 197.803Z",
    stroke: "black",
    strokeWidth: 1.04167
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M212.007 205.365L166.019 128.006L212.007 50.4124L234.241 128.006L212.007 205.365ZM109.492 197.803L51.6193 140.717H143.74L189.797 217.879L109.492 197.803ZM109.492 57.7394L189.562 37.6632L143.505 115.32H51.3907L109.492 57.7394ZM220.991 1.22509L125.067 26.1267C123.416 26.5584 122 27.6251 121.137 29.1045L106.895 53.4918L78.1145 53.2759C76.4256 53.2632 74.8066 53.9172 73.5939 55.0918L3.23198 123.397C0.635157 125.924 0.635157 130.095 3.23833 132.616L73.5939 200.704C74.8002 201.873 76.4256 202.52 78.1082 202.508L106.895 202.292L121.143 226.685C122 228.158 123.41 229.225 125.061 229.657L220.984 254.774C224.388 255.663 227.873 253.65 228.8 250.26L254.495 156.362C254.965 154.654 254.705 152.825 253.778 151.314L239.499 128.031L253.778 104.704C254.705 103.193 254.965 101.365 254.495 99.6568L228.794 5.73938C227.867 2.35525 224.388 0.342552 220.991 1.22509Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 83.3463,
    y1: 14.9775,
    x2: 235.327,
    y2: 266.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnity);
export default __webpack_public_path__ + "static/media/unity.ad58069dbe358b8b7798dbf97edc96f8.svg";
export { ForwardRef as ReactComponent };